import SecurityAuditGraph from "./SecurityAuditGraph";
import { Offcanvas, ListGroup } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle, FaLightbulb } from "react-icons/fa";

const ViewReport = ({ Show, Hide, Title, isDark, report }) => {

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 420 }}>
      <Offcanvas.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} border-bottom`}
      >
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className={isDark ? "bg-dark text-light" : ""}>
        <div className="d-flex justify-content-center">
          <SecurityAuditGraph report={report?.score || 0} />
        </div>
        <div
          className="d-flex justify-content-between text-muted"
          style={{ fontSize: 12 }}
        >
        </div>

        <div className="mb-3">
          <h6 className="fw-semibold mb-2">Security Checks</h6>
          <ListGroup variant="flush">
            {Object.values(report?.checks || {}).map((item, index) => (
              <ListGroup.Item
                key={index}
                className={`d-flex align-items-start gap-2 px-0 ${
                  isDark ? "bg-dark text-light border-secondary" : ""
                }`}
                style={{ fontSize: 13 }}
              >
                {item.status ? (
                  <FaCheckCircle className="text-success mt-1" />
                ) : (
                  <FaTimesCircle className="text-danger mt-1" />
                )}
                <span>{item.message}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>

        {report?.suggestions?.length > 0 && (
          <div className={`border rounded p-3 ${!isDark && "bg-light"}`}>
            <div className="d-flex align-items-center gap-2 mb-2">
              <FaLightbulb className="text-warning" />
              <span className="fw-semibold">Suggestions</span>
            </div>

            <ul className="ps-3 mb-0" style={{ fontSize: 13 }}>
              {report?.suggestions?.map((tip, index) => (
                <li key={index} className="mb-1">
                  {tip}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewReport;
